import styles from "./SettingsContent.module.scss";
import React from "react";
import clsx from "clsx";
import {ContentScroll} from "../../common/Content";

export const SettingsContent = ({children, withFab = false}) => {
  return (
    <ContentScroll withFab={withFab}>
      <div className={clsx(styles.content)}>
        {children}
      </div>
    </ContentScroll>
  );
};
